import React, { useState, useRef } from "react"
import { connect, useSelector } from "react-redux"
import { compose } from "recompose"
import { withMobileDialog, Box, CircularProgress } from "@material-ui/core"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import Button from "@material-ui/core/Button"
import { closeInviteMemberDialog } from "actions/invite-members-dialog"
import DialogsContainerDialog from "../DialogsContainer"
import { userExists } from "actions/user"
import { openSnackBar } from "actions/snack-bar"
import { addUser } from "actions/organization"
import { Formik, Form } from "formik"
import MaskedMobileInput from "components/MaskedMobileInput"
import ReusableFormControl from "components/ReusableFormControl"
import * as Yup from "yup"
const InviteSchema = Yup.object().shape({
  mobile: Yup.string()
    .required("Required")
    .length(14, "Please enter a mobile phone number")
})

const InviteMemberDialog = ({
  fullScreen,
  classes,
  dispatch,
  open,
  ...props
}) => {
  const [mobile, setMobile] = useState("")
  const [loading, setLoading] = useState(false)
  const orgId = useSelector(state => state.organization.currentOrg.id)
  const formRef = useRef()

  const handleClose = () => {
    setLoading(false)
    dispatch(closeInviteMemberDialog())
    setTimeout(() => {
      setMobile("")
    }, 200)
  }

  const addUserToOrg = id => {
    return new Promise((resolve, reject) => {
      dispatch(addUser(id, { user_id: id, org_id: orgId, role_id: "4" }))
        .then(resolve)
        .catch(reject)
    })
  }

  const handleNext = () => {
    formRef.current.submitForm()
    if (formRef.current.isValid) {
      setLoading(true)
      // check if user exists
      dispatch(userExists(mobile))
        .then(res => {
          if (res.phoneNumberExists) {
            // add user to org
            addUserToOrg(res.id)
              .then(() => {
                handleClose()
                dispatch(openSnackBar({ message: "User added to organiation" }))
              })
              .catch(err => {
                console.log(err)
                setLoading(false)
                dispatch(
                  openSnackBar({ message: "Error adding user to organization" })
                )
              })
          } else {
            // invite user
            dispatch(openSnackBar({ message: "User invited" }))
            handleClose()
          }
        })
        .catch(err => {
          console.log(err)
          dispatch(
            openSnackBar({ message: "Error adding user to organization" })
          )
          setLoading(false)
        })
    }
  }

  return (
    <DialogsContainerDialog
      open={open}
      handleClose={() => handleClose("close")}
      title="Invite Member"
      subtitle={"Look up a member by Phone"}
      content={
        <Formik
          innerRef={formRef}
          initialValues={{ mobile }}
          validationSchema={InviteSchema}
          validateOnMount
          onSubmit={() => ""}
          style={{ marginRight: "32px", marginLeft: "32px" }}
        >
          {formikProps => {
            const handleChange = formikProps.handleChange
            formikProps.handleChange = e => {
              setMobile(e.target.value)
              handleChange(e)
            }
            return (
              <Form ref={formRef}>
                <Box
                  display="flex"
                  justifyContent="flex-start"
                  className={classes.phoneContainer}
                >
                  <ReusableFormControl
                    name="mobile"
                    label="Phone"
                    formikProps={formikProps}
                    inputProps={{
                      inputComponent: MaskedMobileInput,
                      className: classes.phone
                    }}
                  />
                </Box>
              </Form>
            )
          }}
        </Formik>
      }
      buttons={
        <Box display="flex">
          <Button onClick={handleClose}>close</Button>
          {!loading ? (
            <Button
              variant="contained"
              className={classes.buttonNext}
              color="primary"
              onClick={handleNext}
            >
              invite
            </Button>
          ) : (
            <Box
              display="flex"
              justify="center"
              style={{ width: "100%", height: "100%" }}
            >
              <CircularProgress color="primary" />
            </Box>
          )}
        </Box>
      }
    />
  )
}

const mapStateToProps = state => {
  return {
    open: state.inviteMembersDialog.open
  }
}

export default compose(
  connect(mapStateToProps),
  withStyles(styles),
  withMobileDialog()
)(InviteMemberDialog)



// WEBPACK FOOTER //
// ./src/dialogs/InviteMember/index.jsx